import { useState } from "react";
import globalRequest from "../../utils/global/globalRequest";
import * as Apis from "../../utils/helper/enum";
import toast from "react-hot-toast";

export const useCommonApi = ({ vandorId = 0 }) => {
  const [allVendor, setAllVendor] = useState([]);
  const [allModifier, setAllModifier] = useState([]);
  const [allModifierWithDetails, setAllModifierWithDetails] = useState([]);
  const [allPackageSize, setAllPackageSize] = useState([]);
  const [allItemSensitivity, setAllItemSensitivity] = useState([]);

  const getAllVendor = async () => {
    try {
      let response = await globalRequest(
        Apis.MANAGE_MODIFIERES.GET_ALL_VENDOR_LIST,
        "get",
        {},
        {},
        true
      );
      let apiResponse = response?.data;
      if (apiResponse.data) {
        let data = apiResponse?.data?.map((item) => {
          return {
            value: item?.id,
            label: item?.vendorDetail.storeName,
          };
        });
        setAllVendor(data || []);
      } else setAllVendor([]);
    } catch (e) {
      toast.error(e?.message);
    }
  };

  const getAllModifier = async (callback) => {
    try {
      if (vandorId === 0) return false;
      let params = {
        vendor_id: vandorId,
      };
      let response = await globalRequest(
        Apis.MANAGE_PRODUCT.GET_ALL_MODIFIER_LIST,
        "get",
        {},
        { params: params },
        true
      );
      let apiResponse = response?.data;
      if (apiResponse?.data) {
        let data = apiResponse?.data?.map((item) => {
          let name_en = "";
          for (let row of item.modifierGroupLocales) {
            if (row.languageCode === "en") name_en = row.name;
          }
          return {
            value: item?.id,
            label: name_en,
            data: item,
          };
        });
        setAllModifier(data);
        setAllModifierWithDetails(apiResponse?.data || []);
        if (callback) callback();
      } else {
        setAllModifier([]);
        setAllModifierWithDetails([]);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  const getAllPackage = async () => {
    try {
      let response = await globalRequest(
        Apis.MANAGE_PRODUCT.GET_PACKAGE_SIZE,
        "get",
        {},
        {},
        true
      );
      let apiResponse = response?.data;
      if (apiResponse?.data?.length) {
        const selectedLanguage = localStorage.getItem("lang") || "en";
        let data = apiResponse?.data?.map((item) => {
          let name =
            item?.locales?.find((l) => l.languageCode === selectedLanguage)?.name ||
            item?.locales?.find((l) => l.languageCode === "en")?.name ||
            item?.name_en ||
            item?.name_ar

          let label = `${name}`;

          return {
            value: item?.id,
            label,
          };
        });
        setAllPackageSize(data || []);
      } else {
        setAllPackageSize([]);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  const getAllItemSensitivity = async () => {
    try {
      let response = await globalRequest(
        Apis.MANAGE_PRODUCT.GET_ITEM_SENSITIVITY,
        "get",
        {},
        {},
        true
      );
      let apiResponse = response?.data;

      if (apiResponse?.data) {
        const currentLanguage = localStorage.getItem("lang") || "en";
        let data = apiResponse.data.map((item) => ({
          value: item?.id,
          label: currentLanguage === "ar" ? item?.name_ar : item?.name_en,
        }));
        setAllItemSensitivity(data || []);
      } else {
        setAllItemSensitivity([]);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  return {
    getAllVendor,
    getAllModifier,
    getAllPackage,
    getAllItemSensitivity,
    allVendor,
    allModifier,
    allModifierWithDetails,
    allPackageSize,
    allItemSensitivity,
  };
};
